<template>
  <Modal
    :width="600"
    :visible="previewVisible"
    title="AI纠错"
    :cancelButtonProps="{ hidden: true }"
    okText="替代原文"
    @cancel="previewVisible = false"
    @ok="onSubmit"
  >
    <div class="model-content">
      <div class="article flex-column">
        <!-- <div class="y-center" style="margin-bottom: 20px">
          <div style="width: 100px; text-align: right">选择模型：</div>
          <div class="y-center">
            <div
              class="nav-item xy-center"
              v-for="(item, index) in modelData.modelList"
              :key="index"
              :class="{ active: index === modelData.modelIndex }"
              @click="modelData.modelIndex = index"
              >{{ item.name }}</div
            >
          </div>
        </div> -->
        <div class="flex">
          <div style="width: 100px; text-align: right">原文：</div>
          <div class="flex1">{{ content }}</div>
        </div>
        <div class="flex" style="margin-top: 30px">
          <div class="x-end" style="width: 100px; text-align: right" @click="onContinue">
            <img
              v-if="loading"
              class="rotate"
              src="@/assets/images/icon_loading@2x.png"
              style="width: 16px; height: 16px; margin-right: 8px"
            />
            <img
              v-else
              src="@/assets/images/pop_aixuxie@2x.png"
              style="width: 16px; height: 16px; margin-right: 8px"
            />
            <span>AI纠错：</span>
          </div>
          <div class="flex1">{{ text }}</div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="x-end">
        <Button class="button none" @click="previewVisible = false">取消</Button>
        <Button class="button" v-if="!loading" type="primary" @click="onSubmit">替代原文</Button>
      </div>
      <!-- <div class="x-end">
        <div class="tips"
          ><span style="color: #f53131">*</span>消耗{{ imagineNum.ai_word }}想象栗，当前剩余{{
            imagineNum.imagine_num
          }}想象栗</div
        >
      </div> -->
    </template>
  </Modal>
</template>

<script>
  import { message, Modal, Button } from 'ant-design-vue';
  import defHttp from '@/jslibs/axios/http';

  export default {
    name: 'AICorrection',
    components: {
      Modal,
      Button,
    },
    props: {
      content: String,
    },
    data() {
      return {
        imagineNum: {},
        previewVisible: false,
        loading: false,
        text: '',
        modelData: {
          modelList: [],
          modelIndex: 0,
          isOpen: false,
        },
      };
    },
    methods: {
      getGptModelList() {
        return defHttp
          .get({
            url: `/cms/AiContent/correctContent`,
          })
          .then((res) => {
            this.modelData.modelList = res.result;
          });
      },
      onShow() {
        this.previewVisible = true;
         this.$nextTick(() => {
          this.text = ''
          this.onContinue();
        });
        // this.getImagineNum();
      },
      onContinue() {
        if (this.loading) return false;
        this.loading = true;
        defHttp
          .post(`/cms/AiContent/correctContent`,{
              content: this.content
            })
          .then((res) => {
            this.loading = false;
            this.text = res.data.result;
            // this.getImagineNum();
          })
          .catch(() => {
            this.loading = false;
          });
      },
      onSubmit() {
        if (this.text === '内容没有文本错别字。') return message.warning(`内容没有文本错别字。`);
        this.$emit('onAiCorrection', `${this.text}`);
         this.previewVisible = false;
      },
      getImagineNum() {
        defHttp
          .get({
            url: `/v1/cms/GetImagineNum`,
          })
          .then((res) => {
            this.imagineNum = res.result;
          });
      },
    },
  };
</script>

<style lang="less" scoped>
  .model-content {
    padding: 24px;
  }

  .article {
    padding: 20px 30px;
    color: #222;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    .nav-item {
      min-width: 90px;
      height: 32px;
      margin-right: 12px;
      padding: 0 10px;
      border-radius: 3px;
      background: #f6f6f6;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      &.active {
        border: 1px solid #000;
        background: #7472f6;
      }
    }
  }

  .tips {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    font-weight: 400;
  }
</style>
